const SIDEBAR_COLLAPSED_STORAGE_KEY = "shipperShipmentSidebarCollapsed";

export function getStoredSidebarCollapsed(): boolean {
  try {
    const stored = localStorage.getItem(SIDEBAR_COLLAPSED_STORAGE_KEY);
    if (stored === null) {
      return true;
    }
    const parsed = JSON.parse(stored);
    return typeof parsed === "boolean" ? parsed : true;
  } catch {
    return true;
  }
}

export function setStoredSidebarCollapsed(collapsed: boolean): void {
  try {
    localStorage.setItem(
      SIDEBAR_COLLAPSED_STORAGE_KEY,
      JSON.stringify(collapsed),
    );
  } catch {
    // localStorage may be unavailable (e.g. private browsing) — the
    // preference just won't persist across sessions in that case.
  }
}
